<script>
	import { page } from '$app/stores';
	import Error from '$lib/components/Error/Error.svelte';

	let customMessageText;

	if ($page.status === 404 && $page.url.pathname === '/profile') {
		customMessageText = 'Access your profile via the People page, or Profiles tile in Portal';
	}
</script>

<Error statusCode={$page.status} {customMessageText} />
